import styled from 'styled-components';
import color from 'tinycolor2';

export const SetupWrapper = styled.div`
  padding: 0 40px 20px;
  margin-top: 20px;
  justify-content: center;
  background-image: url(${(props) => props.theme.backgroundImage});

  background-position: left 10% top 20px;
  @media (max-width: 1000px) {
    background-position: top center;
    background-size: 250px;
    margin-top: 5px;
    padding-top: 100px;
  }
`;

export const SetupHolder = styled.div`
  background: ${(props) => props.theme.stepsBgColor};
  color: ${(props) => props.theme.stepsTextColor};
  border-radius: 4px;
  padding: 20px;
  box-shadow: ${(props) => props.theme.stepsShadow};

  max-width: 536px;
  margin-left: 40%;
  @media (max-width: 1000px) {
    margin: 0px;
    max-width: unset;
    min-width: 330px;
  }
`;

export const StepHeader = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const StepNumber = styled.span`
  display: inline-block;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  text-align: center;
  transition: all 0.3s ease;

  background-color: ${(props) => {
    if (props.done) {
      return color(props.theme['color.primary']).setAlpha(0.2).toString();
    } else if (props.active) {
      return props.theme['color.primary'];
    }
    return props.theme.stepCircleBgColor;
  }};

  ${(props) => props.done ? `
    :before {
      display: inline-block;
      box-sizing: border-box;
      content: "";
      height: 16px;
      width: 8px;
      transition: all 0.3s ease;
      border: 2px solid ${props.theme['color.primary']};
      border-top: 0;
      border-left: 0;
      transform: rotate(45deg) scale(1);
      position: relative;
      top: 4px;
    }
  ` : `
    :before {
      font-size: 14px;
      font-weight: bold;
      line-height: 31px;
      color: ${props.active ? '#FFFFFF' : props.theme.stepCircleNumberColor};
      content: "${props.number}";
      border: none;
      transform: none;
      transition: all 0.3s ease;
    }
  `}
`;

export const StepTitle = styled.span`
  margin-left: 18px;
  font-size: 18px;
  color: ${(props) => props.todo ? props.theme.stepTitleTodoColor : props.theme.stepTitleColor};
`;

export const ContentWrapper = styled.div`
  font-size: 14px;
  padding: 5px 0 20px 34px;
  margin: 10px 10px 10px 16px;
  position: relative;
  ${(props) => props.lastStep ? '' : `border-left: 1px solid ${props.theme.stepVerticalLineColor}`};
  box-sizing: border-box;
`;

export const GrowingWrapper = styled.div`
  transition: all 0.3s ease;
  ${(props) => props.instantDisplay ? `
    opacity: 1;
    height: ${props.height}px;
    overflow: visible;
  ` : `
    opacity: 0;
    height: 0px;
    overflow: hidden;
  `}

  ${(props) => {
    switch (props.transitionState) {
      case 'entering':
        return `
          opacity: 1;
          height: ${props.height}px;
          overflow: hidden;
          transition: all 0.3s ease;
`;
      case 'entered':
        return `
          opacity: 1;
          height: ${props.height}px;
          overflow: visible;
`;
      case 'exiting':
        return `
          opacity: 0;
          height: 0px;
          overflow: hidden;
          transition: all 0.3s ease;
        `;
      default:
        return '';
    }
  }}
`;

export const StepActions = styled.div`
  display: flex;
  flex-wrap: wrap;

  & > * {
    margin-top: 5px;
    margin-right: 15px;
  }
`;

export const VerticalSeparator = styled.div`
  margin-bottom: 20px;
`;

